import {ChecklistIcon} from '@primer/octicons-react'
import {MarkdownRenderer} from '@github-ui/copilot-markdown'
import {stripPlanTags} from '../../utils/plan-tags'
import styles from './DismissedPlanDisplay.module.css'

interface DismissedPlanDisplayProps {
  /** The plan markdown content to render read-only */
  planContent: string
}

export function DismissedPlanDisplay({planContent}: DismissedPlanDisplayProps) {
  const cleanContent = stripPlanTags(planContent).trim()

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <ChecklistIcon size={16} />
        Plan dismissed
      </div>
      {cleanContent && (
        <div className={styles.bordered}>
          <div className={styles.content}>
            <MarkdownRenderer markdown={cleanContent} />
          </div>
        </div>
      )}
    </div>
  )
}
